<template>
    <div class="pdpa-container" v-html="detailText"></div>
</template>

<script>
//service
import BzbsApi from "@/module/Pdpapage/service/RegisterService.js";

export default {
   name: "TermDetail",
    components: {
        
    },
    data: 
        function() {
        return {
            isLoaded: false,
            isHaveItem: false,
            detailText: ''
        };
    },
    created: function() {
        this.getTerm();
    },
    methods: {
        getTerm() {
            BzbsApi.getTerm().then(response => {
                this.detailText = response.data;
                this.isHaveItem = this.detailText ? true : false;
                this.isLoaded = true;
            })
            .catch (() => {
                this.isLoaded = true;
                this.isHaveItem = false;
            });
        },
        switchTab(tabName) {
            this.activeTab = tabName;
        }
    }
};
</script>


<style lang="scss" scoped>
.pdpa-container{
    p{
        padding: 0;
        margin: 0;
    }
}
</style>
